export const COPY_FORM_ERROR_TRY_AGAIN =
  "Please review form errors and re-submit.";
export const COPY_FORM_SUCCESS_DETAILS_SAVED = "Your details have been saved.";
